import { render, staticRenderFns } from "./BillingDelayedTransferTab.vue?vue&type=template&id=2b0b4d0f&scoped=true"
import script from "./BillingDelayedTransferTab.vue?vue&type=script&lang=js"
export * from "./BillingDelayedTransferTab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b0b4d0f",
  null
  
)

export default component.exports